import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../constants/api";
import './style.css';
import { Buffer } from "buffer";


const Events = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [data, setData] = useState([])
  const [updatedId, setUpdatedId] = useState(0)
  const [isUpdate, setIsUpdate] = useState(false)
  const [existingFile, setExistingFile] = useState(null)
  const [newFileSelected, setNewFileSelected] = useState(false)
  const [inputData, setInputData]:any = useState({
    title: '',
    desc: '',
    date: '',
    startTime: '',
    endTime: '',
    selectedFile: null
  });
  let inputRef:any = useRef(null)
  const getAllEvents = async () => {
    try {
      setLoading(true)
      setError('')
      let response = await api(true, `/admin/getAllEvents`, 'get')
      setLoading(false)
      var data = response.data.data.map((event : any) => {
        if(event.selectedFile !== null) {
          return {
            ...event,
            date: moment(event.date).format('YYYY-MM-DD'),
            selectedFile: Buffer.from(event.selectedFile.data)
          }
        }
          else {
            return {
              ...event,
              date: moment(event.date).format('YYYY-MM-DD'),
            }
          }        
      })
      setData(data);
    } catch (error: any) {
      console.log(error)
      setLoading(false)
      setError(error?.response?.data?.message || error.message)
      setData([])
    }
  }

  const handleCreateEvent = async () => {
    if (inputData.title && inputData.desc && inputData.date && inputData.startTime && inputData.endTime) {
      let data:any = { ...inputData };
      if(data['selectedFile']){
        try{
          data['selectedFile'] = await convertImageToBase64(data['selectedFile'])
        }catch(e){
          console.log("error while uploading image")
        }
      }

      data['date'] = moment(data.date).format("YYYY-MM-DD");
      try {
        setLoading(true)
        setError('')
        let response = await api(true, `/admin/createEvent`, 'post', data)
        console.log(response);
        setInputData({
          title: '',
          desc: '',
          date: '',
          startTime: '',
          endTime: '',
          selectedFile: null
        });
        setNewFileSelected(false);
        inputRef.current.value = null
        getAllEvents();
      } catch (error: any) {
        console.log(error)
        setLoading(false)
        setError(error?.response?.data?.message || error.message)
      }
    }
  }

  const handleUpdateEvent = (id: number) => {
    let eventData = data.filter((event: any) => (event.id === id));
    setIsUpdate(true);
    setUpdatedId(id);
    setExistingFile(eventData[0]['selectedFile'])
    setNewFileSelected(false);
    setInputData({
      ...inputData,
      title: eventData[0]['title'],
      desc: eventData[0]['desc'],
      date: eventData[0]['date'],
      startTime: eventData[0]['startTime'],
      endTime: eventData[0]['endTime'],
    })
  }

  const handleDeleteEvent = async (id: number) => {
    try {
      setLoading(true)
      let response = await api(true, `/admin/deleteEvent/${id}`, 'delete')
      console.log(response);
      await getAllEvents();
    } catch (error: any) {
      console.log(error)
      setLoading(false)
      setError(error?.response?.data?.message || error.message)
    }
  }

  function convertImageToBase64(file:any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.readAsDataURL(file);
  
      reader.onload = () => {
        resolve(reader.result);
      };
  
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  const handleSaveEvent = async () => {
    if (updatedId && inputData.title && inputData.desc && inputData.date) {
      try {
        setLoading(true)
        setError('')
        let parsedData:any = { ...inputData }
        // Only convert to base64 if a new file was selected
        if(newFileSelected && parsedData['selectedFile']){
          try{
            parsedData['selectedFile'] = await convertImageToBase64(parsedData['selectedFile'])
          }catch(e){
            console.log("error while uploading image")
          }
        } else {
          delete parsedData['selectedFile'];
        }
        let response = await api(true, `/admin/updateEvent/${updatedId}`, 'put', {
          data: {
            ...parsedData
          }
        });
        console.log(response);
        setUpdatedId(0);
        setInputData({
          title: '',
          desc: '',
          date: '',
          startTime: '',
          endTime: '',
          selectedFile: null
        });
        setIsUpdate(false);
        setExistingFile(null);
        setNewFileSelected(false);
        // console.log(document.getElementById('fileInput').value)
        inputRef.current.value = null
        getAllEvents();
      } catch (error : any) {
        console.log(error)
        setLoading(false)
        setError(error?.response?.data?.message || error.message)
      }
    }
  }
  useEffect(() => {
    getAllEvents();
  }, [])

  return (
    <div className="basePriceContainer">
      <h2 className="h2header basePrice">Events</h2>
      {error && (
        <p style={{ color: 'red' }}>{error}</p>
      )}
      <form className="input-field" >
        <div className="input-group">
          <label htmlFor="title">Title :</label>
          <input type="text" name="title" value={inputData.title} onChange={(e: any) => {
            setInputData({
              ...inputData,
              title: e.target.value
            })
          }} />
        </div>
        <div className="input-group">
          <label htmlFor="desc">Description :</label>
          <textarea className="event-descripition" name="desc" value={inputData.desc} onChange={(e: any) => {
            setInputData({
              ...inputData,
              desc: e.target.value
            })
          }} />
        </div>
        <div className="input-group">
          <label htmlFor="date">Date</label>
          <input type="date" name="date" value={inputData.date} onChange={(e: any) => {
            console.log(e.target.value);
            setInputData({
              ...inputData,
              date: e.target.value
            })
          }} />
        </div>
        <div className="input-group">
          <label htmlFor="startTime">Start Time</label>
          <input type="time" name="startTime" value={inputData.startTime} onChange={(e: any) => {
            console.log(e.target.value);
            setInputData({
              ...inputData,
              startTime: e.target.value
            })
          }} />
        </div>
        <div className="input-group">
          <label htmlFor="endTime">End Time</label>
          <input type="time" name="endTime" value={inputData.endTime} onChange={(e: any) => {
            console.log(e.target.value);
            setInputData({
              ...inputData,
              endTime: e.target.value
            })
          }} />
        </div>
        <div className="input-group">
          <label htmlFor="selectFile">Upload File</label>
          {/* {console.log(inputData.selectedFile?.name)} */}
          {isUpdate && existingFile && !newFileSelected && (
            <div style={{ marginBottom: '10px', padding: '8px', backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
              <small>Current file: <a href={existingFile} target="_blank" rel="noopener noreferrer">View existing file</a></small>
            </div>
          )}
          <input type="file" accept="image/*" name="selectFile" ref={inputRef}  style={{ width: '90%' }} onChange={(e: any) => {
            setNewFileSelected(true);
            setInputData({
              ...inputData,
              selectedFile: e.target.files[0]
            })
          }} />
        </div>
        {!isUpdate ? <button className="submitbtn" onClick={(event: any) => {
          event.preventDefault();
          handleCreateEvent()
        }}>Create</button> : 
        <div style={{ display: 'flex', gap: '10px' }}>
          <button className="submitbtn" onClick={(event: any) => {
            event.preventDefault();
            handleSaveEvent();
          }}>Save</button>
          <button className="btn" onClick={(event: any) => {
            event.preventDefault();
            setIsUpdate(false);
            setUpdatedId(0);
            setExistingFile(null);
            setNewFileSelected(false);
            setInputData({
              title: '',
              desc: '',
              date: '',
              startTime: '',
              endTime: '',
              selectedFile: null
            });
            inputRef.current.value = null;
          }}>Cancel</button>
        </div>}
      </form>
      <div className="table-responsive">
      <table className="tbl styled-table" border={1}>
        <thead>
          <tr>
            <th style={{ minWidth: 50 }}>
              #
            </th>
            <th style={{ minWidth: 100 }}>
              Title
            </th>
            <th style={{ minWidth: 200, maxWidth: 650 }}>
              Description
            </th>
            <th style={{ minWidth: 100 }}>
              DateTime
            </th>
            <th style={{ minWidth: 100 }}>
              StartTime
            </th>
            <th style={{ minWidth: 100 }}>
              EndTime
            </th>
            <th>selectedFile</th>
            <th style={{ minWidth: 200 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan={2}>
                Loading...
              </td>
            </tr>
          )}
          {!loading && (
            data.sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime()).map((item: any) => {
              return (
              <tr key={item.id}>
                <td>
                  {item.id}
                </td>
                <td>
                  {item.title}
                </td>
                <td className="notification-content">{item.desc}</td>
                <td>{item.date}</td>
                <td>{item.startTime}</td>
                <td>{item.endTime}</td>
                <td>
                  <div style={{ height: 200, width: 100 }} >
                    {/* <a href={item.selectedFile} download={true}>Download</a> */}
                    {item.selectedFile !== null ? <a href={item.selectedFile} download={true}>Download</a> : ''}
                  </div>
                </td>
                <td>
                {/* <td style={{ display: "flex", gap: 20, alignItems: "center", justifyContent: "center"}}> */}
                <div style={{ display: "flex", flexDirection: "column", gap: 20, alignItems: "center", justifyContent: "center", alignSelf: "center", alignContent: "center", marginTop: 40, marginBottom: 40, height: "100%" }}>
                  <button className="btn updt" onClick={() => {
                    handleUpdateEvent(item.id);
                  }}>Update</button>
                  <button className="btn dngr" onClick={() => {
                    if (window.confirm("Are you sure you want to delete this event?")) {
                      handleDeleteEvent(item.id);
                    }
                  }}>Delete</button></div>
                </td>
              </tr>
            )})
          )}
        </tbody>
      </table>
      </div>
    </div>
  )
}

export default Events